import TmrBaseResource from './TmrBaseResource'

export default class OperationConfigurations extends TmrBaseResource {
  static endpoint = '/operationConfigurations'
}
